import "./polyfills";
import { createRoot } from "react-dom/client";
import App from "./App";
import installClientDiagnostics from "./helpers/clientDiagnostics";
import { clearLegacyRejectedFeePreviews } from "./helpers/clearLegacyRejectedFeePreviews";
import installModalAriaBridge from "./helpers/modalAriaBridge";
import { initLegacySideMenu } from "./legacy-shell/side-menu";
import { initLegacySiteShell } from "./legacy-shell/site";

async function start() {
  clearLegacyRejectedFeePreviews();
  // Run the legacy shell before the React root renders, matching the old
  // pre-module script timing of public/js/global/site.min.js.
  initLegacySiteShell();
  initLegacySideMenu();
  installClientDiagnostics();
  installModalAriaBridge();

  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<App />);
}

start();
